import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Wed Jul 18 2018
 * @author BPo
 */
import { jsonConversions } from '@logio/common-be-fe';
import api from '../api';
import logger from '../logger';
export var GenericTransportLayer =
/*#__PURE__*/
function () {
  /**
   * @param baseUri Endpoint where we can find all results and base for other api requests like modalData
   */
  function GenericTransportLayer(baseUri) {
    _classCallCheck(this, GenericTransportLayer);

    this.baseUri = baseUri;
  }
  /**
   * Gets all entities from the repository. Use with caution in cases where there are too many entities in repository!
   * @returns all entities from the repository.
   */


  _createClass(GenericTransportLayer, [{
    key: "findAll",
    value: function findAll() {
      var _this = this;

      var findAllPromise = api(this.baseUri).get({
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return findAllPromise;
    }
    /**
     * Gets one particular item based on it's id from repository
     * @returns one particular item from repository
     */

  }, {
    key: "findOne",
    value: function findOne(itemId) {
      var _this2 = this;

      var findOnePromise = api("".concat(this.baseUri, "/").concat(itemId)).get({
        responseType: 'json'
      }).then(function (response) {
        return _this2.getConverter().toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return findOnePromise;
    }
  }]);

  return GenericTransportLayer;
}();